import { TOKEN_KEY } from '../context/AuthContext';

const defaultWebSocketProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';

export const webSocketUrl =
  process.env.REACT_APP_WS_URL || `${defaultWebSocketProtocol}://${window.location.host}/ws`;

export interface ApiModel {
  id: string;
  name: string;
}

export const apiFetch = async (path: string, options: RequestInit = {}) => {
  const token = localStorage.getItem(TOKEN_KEY);
  const headers = new Headers(options.headers);

  if (!headers.has('Content-Type') && options.body) {
    headers.set('Content-Type', 'application/json');
  }

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const response = await fetch(path, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    localStorage.removeItem(TOKEN_KEY);
  }

  return response;
};

export const trackEvent = (event: string, properties: Record<string, unknown> = {}) => {
  apiFetch('/api/events', {
    method: 'POST',
    body: JSON.stringify({ event, properties, occurredAt: new Date().toISOString() }),
  }).catch(() => {});
};

export const getApiErrorMessage = async (response: Response, fallback = 'Something went wrong. Please try again.') => {
  try {
    const data = (await response.json()) as { message?: string; error?: string };
    return data.message || data.error || fallback;
  } catch {
    return fallback;
  }
};
